module.exports = __webpack_public_path__ + "1_0_64/img/note-arrow.a1c8c0dd.svg";